<template>
  <b-container>
    <b-row>
      <b-col cols="8">
        <b-tabs content-class="mt-3">
          <b-tab title="Main">
            <b-row v-show="configIsLoaded()">
              <b-col>
                <div>
                  <b-card no-body>
                    <b-container>
                      <draggable
                        v-model="config.main"
                        tag="ul"
                        class="list-group mt-3"
                        handle=".drag-title">
                        <li
                          v-for="section in config.main"
                          :key="section.id"
                          class="list-group-item">
                          <div>
                            <div class="drag-title">
                              <span
                                v-b-toggle="section.id"
                                class="pointer">
                                <i class="fa fa-folder" />
                                {{ section.name }}
                              </span>
                              <i
                                class="fa fa-times close"
                                @click="confirmRemoval({ id: section.name }, () => removeMainMenuItem(section.id))" />
                            </div>
                            <b-collapse
                              :id="section.id"
                              class="mt-3">
                              <MainMenuItem
                                v-bind="section"
                                @field-update="onMainMenuItemFieldUpdate" />
                            </b-collapse>
                          </div>
                        </li>
                      </draggable>
                      <b-row align-h="end">
                        <b-col
                          class="mt-3 mb-3"
                          cols="auto">
                          <b-button
                            variant="outline-primary"
                            @click="addMainMenuItem()">
                            Add Menu Item
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-card>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="More Menu">
            <b-row v-show="configIsLoaded()">
              <b-col>
                <div>
                  <b-card no-body>
                    <b-container>
                      <b-row class="mt-3">
                        <b-form-radio-group
                          v-model="platform"
                          buttons
                          button-variant="outline-primary"
                          class="RadioGroup ml-3"
                          :disabled="!configIsLoaded()">
                          <b-form-radio
                            v-model="platform"
                            value="ios">
                            <i class="fab fa-apple" />
                          </b-form-radio>
                          <b-form-radio
                            v-model="platform"
                            value="android">
                            <i class="fab fa-android" />
                          </b-form-radio>
                          <b-form-radio
                            v-model="platform"
                            value="unfiltered">
                            <i class="fas fa-times" />
                          </b-form-radio>
                        </b-form-radio-group>
                        <b-form-radio-group
                          v-model="device"
                          buttons
                          button-variant="outline-primary"
                          class="RadioGroup ml-3"
                          :disabled="!configIsLoaded()">
                          <b-form-radio
                            v-model="device"
                            value="phone">
                            <i class="fas fa-mobile-alt" />
                          </b-form-radio>
                          <b-form-radio
                            v-model="device"
                            value="tablet">
                            <i class="fas fa-tablet" />
                          </b-form-radio>
                          <b-form-radio
                            v-model="device"
                            value="unfiltered">
                            <i class="fas fa-times" />
                          </b-form-radio>
                        </b-form-radio-group>
                      </b-row>
                      <draggable
                        v-model="config.more"
                        tag="ul"
                        class="list-group mt-3"
                        handle=".drag-title">
                        <li
                          v-for="section in config.more"
                          :key="section.id"
                          class="list-group-item">
                          <div>
                            <div class="drag-title">
                              <span
                                v-b-toggle="section.id"
                                class="pointer">
                                <i class="fa fa-folder" />
                                {{ section.title }}
                              </span>
                              <i
                                class="fa fa-times close"
                                @click="confirmRemoval({ id: section.title }, () => removeMoreMenuSection(section.id))" />
                            </div>
                            <b-collapse
                              :id="section.id"
                              class="mt-3">
                              <b-form-group
                                :id="$id('moreMenuSectionTitleFieldset')"
                                label-cols="2"
                                label="Title"
                                label-class="pt-0"
                                :label-for="$id('moreMenuSectionTitle')"
                                description="Section Title">
                                <b-form-input
                                  :id="$id('moreMenuSectionTitle')"
                                  v-model="section.title"
                                  :value="section.title"
                                  trim
                                  name="title" />
                              </b-form-group>
                              <b-form-group
                                :id="$id('moreMenuSectionMenusFieldset')"
                                label-cols="2"
                                label="Menu"
                                label-class="pt-0">
                                <MoreMenuSection
                                  :section="section"
                                  :platform="platform"
                                  :device="device" />
                              </b-form-group>
                            </b-collapse>
                          </div>
                        </li>
                      </draggable>
                      <b-row align-h="end">
                        <b-col
                          class="mt-3 mb-3"
                          cols="auto">
                          <b-button
                            variant="outline-primary"
                            @click="addMoreMenuSection">
                            Add Section
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-card>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col class="mt-3">
        <MobilePreview
          :config="config"
          :platform="platform"
          :device="device" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import uuid from 'uuid'
  import MoreMenuSection from '@/components/AppNavigation/MoreMenuSection'
  import MainMenuItem from '@/components/AppNavigation/MainMenuItem'
  import MobilePreview from '@/components/AppNavigation/MobilePreview'
  import draggable from 'vuedraggable'
  import ConfirmRemoval from '@/mixins/ConfirmRemoval'

  export default {
    name: "AppNavigationMenu",
      components: {
        MoreMenuSection,
        MainMenuItem,
        MobilePreview,
        draggable,
      },
      mixins: [ConfirmRemoval],
      props: {
        config: {
          type: Object,
          required: true,
        },
      },
      data: () => ({
        platform: 'unfiltered',
        device: 'unfiltered',
      }),
      methods: {
        addMoreMenuSection() {
            const id = uuid.v4()
            const section = {
                id,
                title: 'New Section',
                type: '',
                menus: [],
            }

            this.config.more.push(section)
        },
        removeMoreMenuSection(sectionId) {
          for (let i = 0; i < this.config.more.length; i++) {
            const section = this.config.more[i]
            if (section.id === sectionId) {
              this.config.more.splice(i, 1)
              break
            }
          }
        },
        addMainMenuItem() {
          const subId = uuid.v4()

          const menuItem = {
              id: subId,
              android: true,
              ios: true,
              lite: true,
              name: 'New Menu Item',
              paid: true,
              phone: true,
              tablet: true,
              type: 'tab-bar',
              visible: true,
              url: 'mlbatbat://game/123',
              icon: 'https://mlb.mlb.com/assets/images/icon.png',
              accessibilityText: 'English Alt Text',
          }

          this.config.main.push(menuItem)
        },
        removeMainMenuItem(id) {
          for (let i = 0; i < this.config.main.length; i++) {
            const item = this.config.main[i]
            if (item.id === id) {
              this.config.main.splice(i, 1)
              break
            }
          }
        },
        onMainMenuItemFieldUpdate(data) {
          for (let i = 0; i < this.config.main.length; i++) {
            const item = this.config.main[i]
            if (item.id === data.id) {
              item[data.field] = data.value
              break
            }
          }
        },
        configIsLoaded() {
          return this.config != null
        },
      },
  }
</script>
